import { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { MainLayout } from "layouts";

import {
	HelmetPageTitle,
	NotificationDetails as NotificationDetailsComponent,
} from "components";

import { TStore } from "models";
import { setMarketplaceOffersQuery } from "store";

const stateSelectorHandle = createSelector(
	(state: TStore) => state.marketplaceOffers,
	(state: TStore) => state.auth.credentials,
	(state: TStore) => state.app.currentCommunityId,
	(state: TStore) =>
		state.posts?.meta?.appearance?.marketplace_display_name?.plural,
	(
		marketplaceOffers,
		credentials,
		currentCommunityId,
		marketplaceOffersDisplayName,
	) => ({
		marketplaceOffers,
		credentials,
		currentCommunityId,
		marketplaceOffersDisplayName,
	}),
);

const NotificationDetails = () => {
	const dispatch = useDispatch();
	const stateSelector = useCallback(stateSelectorHandle, []);
	const { marketplaceOffersDisplayName } = useSelector(stateSelector);

	useEffect(() => {
		return () => {
			dispatch(setMarketplaceOffersQuery({ query: "" }));
		};
	}, [dispatch]);

	return (
		<>
			<HelmetPageTitle
				screenTitle={
					marketplaceOffersDisplayName
						? marketplaceOffersDisplayName
						: "Marketplace"
				}
			/>
			<MainLayout>
				<NotificationDetailsComponent />
			</MainLayout>
		</>
	);
};

export default memo(NotificationDetails);
